import React, { useState } from 'react';
import { IconArrow, IconMinus, IconPlus } from '../Servicetjek.icons';
import { TMessageLink, TMessageLinkList } from './MessageLinkList.definition';

const MessageLink = (props: TMessageLink) => {
	const {
		title,
		iFokus,
		erLaest,
		oprettetDato,
		target,
		url
	} = props;

	const dateFormatted = new Date(oprettetDato).toLocaleDateString('da-DK');

	return (
		<li className={ ['message-link', iFokus ? 'focus' : ''].join(' ') }>
			<a href={ url } target={ target } className="link">
				{ !erLaest &&
					<div className="dot" /> }

				<div className="text">
					<strong className="title">{ title }</strong>
					<span className="date">{ dateFormatted }</span>
				</div>
				<IconArrow />
			</a>
		</li>
	);
};


export const MessageLinkList = (props: TMessageLinkList) => {
	const {
		overskrift,
		meddelelser
	} = props;

	const hasMessages = meddelelser && meddelelser.length > 0;

	if (!hasMessages) {
		return null;
	}

	const aboveThreshold = meddelelser && meddelelser.length > 4;
	const [expanded, setExpanded] = useState(false);

	return (
		<>
			{ overskrift &&
				<p><strong>{ overskrift }</strong></p> }

			<ul className={ ['message-link-list', expanded ? '' : aboveThreshold ? 'limited' : ''].join(' ') }>
				{ meddelelser
					.filter((m, idx) => {
						return !(!expanded && idx > 3);
					})
					.map((m, idx) => <MessageLink key={ idx } { ...m } />) }
			</ul>

			{ aboveThreshold && (
				<a
					className="button-expand"
					onClick={ () => setExpanded(!expanded) }
				>
					<div className="icon">{ expanded ? <IconMinus /> : <IconPlus /> }</div>
					<span>{ expanded ? 'Vis færre' : 'Vis flere' }</span>
				</a>
			) }
		</>
	);
};


export const MessageLinks = (props: TMessageLinkList) => {
	return (
		<section className="f-grid message-links">
			<div className="col-sm-6 col-md-12 col-lg-12">
				<MessageLinkList { ...props } />
			</div>
		</section>
	);
};

export default MessageLinks;
